<div class="wrapper">
  <div class="container-fluid"  style="margin-bottom: 6px;">
    <div class="row default-dadhboard" style="border:0;">
      <div class="col-12" style="position: relative; border: 0;">
        <div class="page-title-box" style="width: 360px; height: 44px;">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
            </ol>
          </div>
          <div class="col-12" *ngIf="canViewParticipantDashboard" style="height:36px;">
            <a href="#" class="" (click)="showDashboard('default')" style="float: left; font-size: 22px; padding-right: 4px;">Dashboard</a>
            <a href="#" class="" style="float: left; font-size: 22px; ">/</a>
            <a href="#" class="" (click)="showDashboard('chatgraphs')" style="float: left; padding-left: 2px; font-size: 22px;" >Participant Statistics</a>
          </div>
        </div>

        <div *ngIf="hasBillingReport" style="left: 362px; right: 10px; top: 6px; height: 44px;position: absolute;">
          <div class="form-group row">
              <div class="form-group col-md-41" style="right: 520px; position: absolute;">
                <label class="col-md-2 col-form-label">Date </label>
                <ng-select2 [data]="merchantBillingDates"
                            [value]="selectedMerchantBillingDate"
                            [width]="240"
                            [placeholder]="'Please select ...'"
                            (valueChanged)="onSelectedMerchantBillingByDate($event)">
                </ng-select2>
              </div>

              <div class="form-group col-md-61" style="right: 120px; position: absolute;">
                <label class="col-form-label">Select Participant</label>
                <ng-select2 class="col-md-6" [data]="merchantBillingNames"
                            [value]="selectedMerchantBillingName"
                            [width]="260"
                            [placeholder]="'Please select ...'"
                            (valueChanged)="onSelectedMerchantBilling($event)">
                </ng-select2>
              </div>
              <a href="#" class="btn btn-primary" (click)="viewDataTable()" style="width: 100px; right: 5px; font-size: 14px; position: absolute;">View Data</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="default-dadhboard container-fluid" *ngIf="currentDashboard === 'default'">
    <dashboard-default-component></dashboard-default-component>
  </div>
  <div class="chatgraphs-dashboard container-fluid" *ngIf="isChatGraphs === 'chatgraphs'" [style.display]="isVisible ? 'block' : 'none'">
    <merchant-graphs-component (valueChanged)="receiveValue($event)"
                               (hasBillingReport)="handleBillingReportAvailability($event)"
                               [getBillingDate]="setBillingDate" *ngIf="reloadGraphs"></merchant-graphs-component>
  </div>

</div>
